import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import styles from '@app/modules/projects/dashboard/shared/per-year-capital-structure/per-year-capital-structure-chart.module.scss';

const PARENT_CLASSNAME = 'total-equity-chart';

interface ChartColumnProps {
  height?: string;
  children: ReactNode;
  onClick?: () => void;
  className?: string;
}

const ChartColumn: FC<ChartColumnProps> = ({ height, children, onClick, className }) => (
  <div
    className={classNames(
      styles[`${PARENT_CLASSNAME}__column`],
      styles[`${PARENT_CLASSNAME}__column--expanded`],
      { [styles['cursor-pointer']]: onClick },
      className
    )}
    style={height ? { height } : undefined}
    onClick={onClick}>
    {children}
  </div>
);

export default ChartColumn;
